import { Injectable } from "@angular/core";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { FloorplanImage } from "@domain/project/floorplan/floorplan-image";
import { FloorplanWorkspace } from "@project/floorplanner/floorplan-workspace";
import { catchError, Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class FloorplanWorkspaceItemService {
  public addItems(floorplan: Floorplan, floorplanWorkspace: FloorplanWorkspace): Observable<undefined> {
    floorplan.exZones.forEach((item) => floorplanWorkspace.addExZone(item, false));
    floorplan.dustExZones.forEach((item) => floorplanWorkspace.addDustExZone(item, false));
    floorplan.wildcardZones.forEach((item) => floorplanWorkspace.addWildcardZone(item, false));
    floorplan.pipelines.forEach((item) => floorplanWorkspace.addPipeline(item, false));
    floorplan.cableRoutes.forEach((item) => floorplanWorkspace.addCableRoute(item, false));
    floorplan.protectiveTubes.forEach((item) => floorplanWorkspace.addProtectiveTube(item, false));
    floorplan.wires.forEach((item) => floorplanWorkspace.addWire(item, false));
    floorplan.airPaths.forEach((item) => floorplanWorkspace.addAirPath(item, false));
    floorplan.measurementLines.forEach((item) => floorplanWorkspace.addMeasurementLine(item, false));
    if (floorplan.referenceMeasure) floorplanWorkspace.addReferenceMeasure(floorplan.referenceMeasure, false);
    floorplan.dangerAreas.forEach((item) => floorplanWorkspace.addDangerArea(item, false));
    floorplan.floorplanTexts.forEach((item) => floorplanWorkspace.addText(item, false));
    floorplan.floorplanFreeTexts.forEach((item) => floorplanWorkspace.addFreeText(item, false));
    this.addFloorplanImages(floorplan.images, floorplanWorkspace);
    floorplan.plasticSigns.forEach((item) => floorplanWorkspace.addPlasticSign(item, false));
    floorplan.plasticSignPlaceholders.forEach((item) => floorplanWorkspace.addPlasticSign(item, false));
    floorplan.signalElements.forEach((item) => floorplanWorkspace.addSignalElement(item, false));
    floorplan.signalElementPlaceholders.forEach((item) => floorplanWorkspace.addSignalElement(item, false));
    floorplan.transmitters.forEach((item) => floorplanWorkspace.addTransmitter(item, false));
    floorplan.transmitterPlaceholders.forEach((item) => floorplanWorkspace.addTransmitter(item, false));
    floorplan.flameDetectors.forEach((item) => floorplanWorkspace.addFlameDetector(item, false));
    floorplan.flameDetectorPlaceholders.forEach((item) => floorplanWorkspace.addFlameDetector(item, false));
    floorplan.gasWarningCenters.forEach((item) => floorplanWorkspace.addGasWarningCenter(item, false));
    floorplan.gasWarningCenterPlaceholders.forEach((item) => floorplanWorkspace.addGasWarningCenter(item, false));
    floorplan.alarmDevices.forEach((item) => floorplanWorkspace.addAlarmDevice(item, false));
    floorplan.alarmDevicePlaceholders.forEach((item) => floorplanWorkspace.addAlarmDevice(item, false));
    floorplan.patientMonitors.forEach((item) => floorplanWorkspace.addPatientMonitor(item, false));
    floorplan.patientMonitorPlaceholders.forEach((item) => floorplanWorkspace.addPatientMonitor(item, false));
    floorplan.centralStations.forEach((item) => floorplanWorkspace.addCentralStation(item, false));
    floorplan.centralStationPlaceholders.forEach((item) => floorplanWorkspace.addCentralStation(item, false));
    floorplan.telemetries.forEach((item) => floorplanWorkspace.addTelemetry(item, false));
    floorplan.telemetryPlaceholders.forEach((item) => floorplanWorkspace.addTelemetry(item, false));
    floorplan.kvms.forEach((item) => floorplanWorkspace.addKvm(item, false));
    floorplan.kvmPlaceholders.forEach((item) => floorplanWorkspace.addKvm(item, false));
    floorplan.displays.forEach((item) => floorplanWorkspace.addDisplay(item, false));
    floorplan.displayPlaceholders.forEach((item) => floorplanWorkspace.addDisplay(item, false));
    floorplan.utilities.forEach((item) => floorplanWorkspace.addUtility(item, false));
    floorplan.utilityPlaceholders.forEach((item) => floorplanWorkspace.addUtility(item, false));
    floorplan.isolationRooms.forEach((item) => floorplanWorkspace.addIsolationRoom(item, false));
    floorplan.itRooms.forEach((item) => floorplanWorkspace.addItRoom(item, false));
    floorplan.operatingTheatres.forEach((item) => floorplanWorkspace.addOperatingTheatre(item, false));
    floorplan.procedureRooms.forEach((item) => floorplanWorkspace.addProcedureRoom(item, false));
    floorplan.standardRooms.forEach((item) => floorplanWorkspace.addStandardRoom(item, false));
    floorplan.project.getGroupsOnFloorplan(floorplan.id).forEach((item) => floorplanWorkspace.createGroup(item));
    return of(undefined);
  }

  private addFloorplanImages(images: FloorplanImage[], floorplanWorkspace: FloorplanWorkspace) {
    images.forEach((image) => {
      floorplanWorkspace
        .addImage(image, false)
        .pipe(
          catchError((error) => {
            console.error("Failed to add floorplan image during initialization:", error);
            return of(undefined);
          }),
        )
        .subscribe();
    });
  }
}
